/* Action Types */
export const CALL_GET_STORAGE_LOCAL = 'CALL_GET_STORAGE_LOCAL';
export const GET_STORAGE_LOCAL_SUCCESS = 'GET_STORAGE_LOCAL_SUCCESS';
export const GET_STORAGE_LOCAL_FAILED = 'GET_STORAGE_LOCAL_FAILED';
export const SET_USER_AVATAR_URL = 'SET_USER_AVATAR_URL';
export const FORM_SUBMIT = 'FORM_SUBMIT';
export const FORM_SUBMIT_SUCCESS = 'FORM_SUBMIT_SUCCESS';
export const FORM_SUBMIT_FAILED = 'FORM_SUBMIT_FAILED';

/* Reducer */
const INITIAL_STATE = {
    avatar: {
        loading: false,
        storageLocal: null,
        avatarUrl: null,
        error: null
    },
    formSubmit: {
        loading: false,
        error: null,
        data: null,
        redirectUrl: null
    },
};

export default function reducer(state = INITIAL_STATE, action) {
    const { storageLocal, error, type, avatarUrl, data } = action;

    switch (type) {
        case CALL_GET_STORAGE_LOCAL:
            return { ...state,
                avatar: {
                    ...state.avatar,
                    loading: true
                }
            };
        case GET_STORAGE_LOCAL_SUCCESS:
            return { ...state,
                avatar: {
                    ...state.avatar,
                    loading: false,
                    storageLocal
                }
            };
        case GET_STORAGE_LOCAL_FAILED:
            return { ...state,
                avatar: {
                    ...state.avatar,
                    loading: false,
                    error
                }
            };
        case SET_USER_AVATAR_URL:
            return { ...state,
                avatar: {
                    ...state.avatar,
                    loading: false,
                    avatarUrl
                }
            };
        case FORM_SUBMIT:
            return { ...state,
                formSubmit: {
                    ...state.formSubmit,
                    loading: true
                }
            }
        case FORM_SUBMIT_SUCCESS:
            return { ...state,
                formSubmit: {
                    ...state.formSubmit,
                    loading: false,
                    redirectUrl: data.redirectUrl,
                    data
                }
            }
        case FORM_SUBMIT_FAILED:
            return { ...state,
                formSubmit: {
                    ...state.formSubmit,
                    loading: false,
                    error
                }
            };
        default:
            return state;
    }
}

/* Action Creators */

export const getStorageLocal = data => {
    return { type: CALL_GET_STORAGE_LOCAL, data }
};

export const getStorageLocalSuccess = storageLocal => {
    return { type: GET_STORAGE_LOCAL_SUCCESS, storageLocal }
};

export const getStorageLocalFaild = error => {
    return { type: GET_STORAGE_LOCAL_FAILED, error }
};

export const setUserAvatarUrl = avatarUrl => {
    return { type: SET_USER_AVATAR_URL, avatarUrl }
};

export const formSubmit = data => {
    return { type: FORM_SUBMIT, data }
};

export const formSubmitSuccess = data => {
    return { type: FORM_SUBMIT_SUCCESS, data }
};

export const formSubmitFailed = error => {
    return { type: FORM_SUBMIT_FAILED, error }
};



// WEBPACK FOOTER //
// ./src/ducks/User.js